import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/pages/index'
import HaiBao from '@/pages/haibao'
import Video from '@/pages/video'
import GuanYuWoMen from '@/pages/guanyuwomen'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: Index
    },
    {
      path: '/haibao',
      name: 'haibao',
      component: HaiBao
    },
    {
      path: '/video',
      name: 'video',
      component: Video
    },
    {
      path: '/guanyuwomen',
      name: 'guanyuwomen',
      component: GuanYuWoMen
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    return savedPosition || { x: 0, y: 0 }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js